import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import { Content } from "../Components/Typo";
import { Link } from "react-router-dom";
import { animate, motion } from "framer-motion";
import { Fullscreen } from "../Components/styled/Image";
import earth from "../assets/images/earth.jpg";
import { Column } from "../Components/styled/Layout";
import { Title, Subtitle, Paragraph } from "../Components/styled/Typo";
import { BlockButton, NextButton } from "../Components/styled/Button";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import astronautre from "../assets/images/lune.jpg";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  cursor: all-scroll;
`;

const Description = styled.div`
  color: #000;
  width: 50vw;
  height: 100vh;
  background: #f6f6f633;
  backdrop-filter: blur(25px);
  border-bottom: 1px solid #000;
  padding-left: 50px;
  padding-right: 50px;
`;

const Illustration = styled.div`
  width: 50vw;
  background-image: ${(props) => `url("${props.url}")`};
  background-position: center;
  background-size: cover;
  object-fit: cover;
  object-position: center top;
  background-position: center;
  height: 100vh;
`;

const TitleStyled = styled(Title)`
  text-align: center;
  margin-top: 60px;
`;

const SubtitleStyled = styled(Subtitle)`
  text-align: center;
  margin-top: 60px;
`;
const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Button = styled(Link)`
  cursor: pointer;
  justify-self: center;
  width: 250px;
  border-radius: 25px;
  margin-top: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

const ItemDescription = styled(Content)`
  margin: 0px;
`;

const Image = styled.img`
  width: 150px;
  height: 75px;
  cursor: zoom-in;
  object-fit: cover;
  margin: 5px;
  margin-right: 15px;
  border: ${(props) => (props.bordering ? "2px red solid" : "0px red solid")};
`;

const Background = styled.img`
  position: absolute;
  display: block;
  object-fit: cover;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 650px;
  height: 450px;
  border-radius: 10px;
`;

const ModalStyled = styled(Modal)`
  backdrop-filter: blur(2px);
`;

export default function HumanSecond() {
  const { t } = useTranslation();

  const prev = () => {};
  return (
    <>
      <motion.div
        className="container"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 1, x: -100, transition: { duration: 0.1 } }}
      >
        <FirstSection id="secondHuman" style={{ background: "#141414" }}>
          <div>
            <Fullscreen
              src={astronautre}
              style={{ objectFit: "contain", objectPosition: "left" }}
            />
          </div>
          <CardContainer>
            <div>
              <Column>
                <Title>{t("humanSubtitle")}</Title>
                <Subtitle style={{ fontSize: "1.1rem", marginTop: 10 }}>
                  {t("humanDescription3")}
                </Subtitle>
              </Column>
              <br />
              <BlockButton>
                <NextButton to={"/human"}>
                  <FaAngleLeft />
                </NextButton>
                <NextButton to={"/solar"}>
                  <FaAngleRight />
                </NextButton>
              </BlockButton>
            </div>
          </CardContainer>
        </FirstSection>
      </motion.div>
    </>
  );
}

export const FirstSection = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: red;
`;

export const CardContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 600px;
  height: 100vh;
  background: #d6f8f633;
  backdrop-filter: blur(25px);
  padding: 20px;
`;

export const Row = styled.div`
  width: 100%;
  border: 2px solid #d3d3d3;
  padding: 10px;
  margin-top: 25px;
  height: 150px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  transition: linear 1s;
  box-shadow: 0.5px 3px 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
`;

export const SmallImage = styled.img`
  border-radius: 5px;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
